import { z } from "zod"

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_API_MODE: z.enum(["mock", "real"]).default("mock"),
  VITE_AUTH0_DOMAIN: z.string().min(1),
  VITE_AUTH0_CLIENT_ID: z.string().min(1),
  VITE_AUTH0_AUDIENCE: z.string().min(1),

  // Optional: redirect_uri is typically derived from window.location.origin
  VITE_AUTH0_REDIRECT_URI: z.string().url().optional(),

  // 🔐 DEFAULT NOW = "auth"
  VITE_UI_SHELL_MODE: z.enum(["public", "auth"]).default("auth"),

  VITE_UI_ADMIN_MODE: z.enum(["auto", "on", "off"]).default("auto"),

  // Debug override (UI-only): if true, treat user as admin in the UI
  VITE_DEBUG_IS_ADMIN: z.enum(["true", "false"]).default("false"),

  // Observability configuration
  VITE_OBS_PROVIDER: z.enum(["sentry", "noop"]).default("noop"),
  VITE_OBS_DSN: z.string().optional(),
  VITE_ENVIRONMENT: z.enum(["local", "preview", "staging", "prod"]).default("local"),
  VITE_RELEASE: z.string().optional(),
})

function getEnv() {
  const env = {
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
    VITE_API_MODE: (import.meta.env.VITE_API_MODE ?? "mock") as unknown,
    VITE_AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN,
    VITE_AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID,
    VITE_AUTH0_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE,
    VITE_AUTH0_REDIRECT_URI: import.meta.env.VITE_AUTH0_REDIRECT_URI as unknown,

    // 🔐 DEFAULT NOW = "auth"
    VITE_UI_SHELL_MODE: (import.meta.env.VITE_UI_SHELL_MODE ?? "auth") as unknown,

    VITE_UI_ADMIN_MODE: (import.meta.env.VITE_UI_ADMIN_MODE ?? "auto") as unknown,
    VITE_DEBUG_IS_ADMIN: (import.meta.env.VITE_DEBUG_IS_ADMIN ?? "false") as unknown,

    VITE_OBS_PROVIDER: (import.meta.env.VITE_OBS_PROVIDER ?? "noop") as unknown,
    VITE_OBS_DSN: import.meta.env.VITE_OBS_DSN as unknown,
    VITE_ENVIRONMENT: (import.meta.env.VITE_ENVIRONMENT ?? "local") as unknown,
    VITE_RELEASE: import.meta.env.VITE_RELEASE as unknown,
  }

  const parsed = envSchema.safeParse(env)

  if (!parsed.success) {
    console.error(
      "Invalid environment variables:",
      parsed.error.flatten().fieldErrors
    )
    throw new Error("Invalid environment variables")
  }

  return parsed.data
}

export const env = getEnv()
